import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TokenIdService {
  constructor() {}

  getAuthToken(): string | null {
    return localStorage.getItem('authToken');
  }

  decodeToken(token: string): any {
    if (!token) return null;
    try {
      const payload = token.split('.')[1];
      return JSON.parse(atob(payload));
    } catch (e) {
      return null;
    }
  }

  getTokenPayload(token?: string): any | null {
    const t = token || this.getAuthToken();
    return this.decodeToken(t || '');
  }

  getExpiry(token?: string): number | null {
    const payload = this.getTokenPayload(token);
    return payload?.exp ?? null; // exp in seconds
  }

  isTokenExpired(token?: string, nowMs: number = Date.now()): boolean {
    const expSec = this.getExpiry(token);
    if (!expSec) return true; // treat missing exp as expired
    return expSec * 1000 <= nowMs;
  }

  clearTokens(): void {
    try {
      localStorage.removeItem('authToken');
      localStorage.removeItem('refreshToken');
    } catch {}
  }

  getUserIdFromToken(token?: string): string | null {
    const t = token || this.getAuthToken();
    const decoded = this.decodeToken(t || '');
    return decoded?.id || decoded?._id || decoded?.userId || null;
  }

  getAdminIdFromToken(token?: string): string | null {
    const t = token || this.getAuthToken();
    const decoded = this.decodeToken(t || '');
    return decoded?.id || decoded?._id || decoded?.adminId || null;
  }

  getRoleTypeFromToken(token?: string): string | null {
    const t = token || this.getAuthToken();
    const decoded = this.decodeToken(t || '');
    return decoded?.roleType || decoded?.role || null;
  }
}